import { GraduationCap } from "lucide-react";
import { useTranslation } from "react-i18next";
import { PrimaryButton } from "src/components/Default/LekUI/Button";

import { SelectionBar } from "./SelectionBar";

interface DecksLearnSelectionBarProps {
	selectedCount: number;
	onLearn: () => void;
	onClose: () => void;
	isLearning: boolean;
}

export const DecksLearnSelectionBar = ({
	selectedCount,
	onLearn,
	onClose,
	isLearning,
}: DecksLearnSelectionBarProps) => {
	const { t } = useTranslation();

	return (
		<SelectionBar
			selectedCount={selectedCount}
			onClose={onClose}
			actions={
				<PrimaryButton
					data-test-id="decks-selection-learn-button"
					onClick={onLearn}
					disabled={isLearning || selectedCount === 0}
					className="flex items-center gap-8 folder-selection-bar-btn"
				>
					<GraduationCap className="icon-small" />
					<span className="folder-selection-bar-text">
						{t("decks.search.learnSelected", "Ucz się z tych zestawów")}
					</span>
				</PrimaryButton>
			}
		/>
	);
};
